import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ToastService } from '../services/toast.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    const chunkFailedMessage = /Failed to fetch dynamically imported module|Loading chunk failed/;

    if (chunkFailedMessage.test(error.message)) {
      console.warn('Chunk loading failed. Reloading page...', error);
      window.location.reload();
      return;
    }

    console.error('An unhandled error occurred:', error);

    try {
      const toastService = this.injector.get(ToastService);
      toastService.error('toast.genericError');
    } catch (e) {
      console.error('Failed to show error toast:', e);
    }
  }
}
